export default {
  buttons: {
    more_payment_methods: 'Mais métodos de pagamento',
  },
  toasts: {
    processing: 'A processar dados de pagamento. Iremos avisá-lo quando o processamento estiver concluído.',
    failed: 'Falha ao processar os dados de pagamento. Por favor, tente outro método de pagamento.',
    failed_to_load: 'O formulário de pagamento não pôde ser carregado. Recarregue a página e tente novamente.',
    failed_to_save_payment_method: 'Falha ao guardar o método de pagamento',
    failed_to_create_checkout_session: 'Ocorreu um erro, por favor tente novamente',
  },
};
